'use client';

import { ArrowDropDown } from '@mui/icons-material';
import { TranslatableButton } from '@epos/ui/components';
import { CssVarsTheme, Menu, useMediaQuery } from '@mui/material';
import { useRef, useState } from 'react';

import { MembershipProgrammeTermsDialog } from '@/components/membership-programme-terms-dialog';
import { useAppSelector } from '@/hooks/use-app-selector';
import { useToggle } from '@/hooks/use-toggle';
import { useQueryConfigs } from '@/query/hooks/use-query-configs';

import ChangePasswordOption from './change-password-option';
import LogoutOption from './logout-option';
import MembershipProgrammeTermsOption from './membership-programme-terms-option';

const BUTTON_LABEL = 'Your account';

const AccountMenu: React.FC<{ isMobileInit?: boolean; user?: CustomerPortalUser }> = ({ isMobileInit, user }) => {
  const { isOpen, handleOpen, handleClose } = useToggle();
  const [isTermsDialogOpen, setIsTermsDialogOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const isMobile = useMediaQuery((theme: CssVarsTheme) => theme.breakpoints.down('md'), {
    defaultMatches: isMobileInit
  });
  const currentUser = useAppSelector((state) => state.auth.user) || user;
  const { data: configs } = useQueryConfigs();

  return (
    <>
      <TranslatableButton
        variant='outlined'
        color='neutral'
        className='!border-neutral-00 md:!border-1.5 !rounded-3xl !border-0'
        endIcon={<ArrowDropDown fontSize='large' />}
        onClick={handleOpen}
        ref={buttonRef}
      >
        {isMobile ? `Hi, ${currentUser?.customerName}` : BUTTON_LABEL}
      </TranslatableButton>
      <Menu
        open={isOpen}
        onClose={handleClose}
        anchorEl={buttonRef.current}
        closeAfterTransition
        slotProps={{
          paper: {
            sx: {
              minWidth: buttonRef.current?.offsetWidth
            }
          }
        }}
      >
        <ChangePasswordOption closeMenu={handleClose} />
        <MembershipProgrammeTermsOption
          closeMenu={handleClose}
          onOpenTermsDialog={() => setIsTermsDialogOpen(true)}
        />
        <LogoutOption />
      </Menu>
      <MembershipProgrammeTermsDialog
        open={isTermsDialogOpen}
        onClose={() => setIsTermsDialogOpen(false)}
        merchantName={configs?.companyName}
      />
    </>
  );
};

export default AccountMenu;
